// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"f5121d41","398":"9747218f","630":"b8636537","813":"1c52ee20"}[chunkId] + ".chunk.css";
};